import { Route, Switch, useRouteMatch } from "react-router-dom";
import SettingsContainersList from "./SettingsContainersList";
import ZoneSettingsCreateEditor from "../zones/ZoneSettingsCreateEditor";
import ZoneSettingsPage from "../zones/ZoneSettingsPage";

const SettingsContainers = ({ token, API }) => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <SettingsContainersList token={token} API={API} basePath={path} />
      </Route>
      <Route exact path={`${path}/new`}>
        <ZoneSettingsCreateEditor token={token} />
      </Route>
      <Route path={`${path}/:id`}>
        <ZoneSettingsPage token={token} />
      </Route>
    </Switch>
  );
};

export default SettingsContainers;
